// sliders.js
// let partnersSlider;
// function checkSizePartnersSlider() {
//     console.log("checkSizeTeamSwiper");
//     partnersSlider = $(".partnersSlider");
//     let offset = partnersSlider.offset();
//     partnersSlider.width(window.innerWidth - offset.left);
// };
// function initCheckSizePartnersSlider() {
//     checkSizePartnersSlider();
//     $(window).on("resize.partnersSlider", this.checkSizePartnersSlider);
// }
function initSwiperSliders() {
    let isLastQuestion = false;
    new Swiper($(".test-slider .swiper-container"), {
        loop: false,
        autoHeight: true,
        slidesPerView: 1,
        //effect: 'fade',
        spaceBetween: 60,
        allowTouchMove: false,
        focusableElements: 'label, input',
        noSwipingSelector: 'label, input',
        passiveListeners: false,
        preventClicks: false,
        preventInteractionOnTransition: true,
        navigation: {
            prevEl: $(".b-test .prev-btn.js"),
            nextEl: $(".b-test .next-btn"),
        },
        on: {
            reachEnd() {
              isLastQuestion = true;
              $(".b-test .next-btn").addClass('hide');
              $(".b-test .form-btn").addClass('active');
            },
            slidePrevTransitionStart() {
              if (isLastQuestion) {
                isLastQuestion = false
                $(".b-test .next-btn").removeClass('hide');
                $(".b-test .form-btn").removeClass('active');
              }
              $(".b-test .next-btn").css('pointer-events','all').css('opacity','1');
            },
            slideNextTransitionStart() {
              if( $(".swiper-slide.swiper-slide-active .test-block .form-group:last-child input").val() == '' || $(".swiper-slide.swiper-slide-active .test-block .form-group:nth-last-child(2) input").val() == '' ){
                $(".b-test .next-btn").css('pointer-events','none').css('opacity','0.8');
              }
              else{
                $(".b-test .next-btn").css('pointer-events','all').css('opacity','1');
              }
            }
        }
    });
};